// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1ZIaA","head":"Table_head__2qh86","col":"Table_col__5rIez"};